import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  submitted = false;
  error = false;
  success = false;
  repeatPasswordForm: FormGroup;
  confirmPasswordCheck = false;
  showResetPassword = false;
  showConfirmMsg = false;
  showConfirmMsgAlert = false;
  activationCode = '';
  data: any;
  header: string;
  url1: string = "";

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private commonUtilService: CommonUtilService,
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();
    this.url1 = this.router.url;
    this.repeatPasswordForm = this.repeatPasswordFormBuilder(this.formBuilder);

    if (location.href.includes("profile/password") || location.href.includes("admin/password")) {
      this.showResetPassword = false;
      this.commonUtilService.translateLang("HRWE.PAGE_TITLE.MY_PROFILE_PASSWORD");

      this.header = "HRWE.RESET-PASSWORD.TITLE_CHANGE_PASSWORD";

      this.activationCode = null;
      this.spinnerService.stop();
    } else {
      this.activationCode = this.route.snapshot.paramMap.get('activationCode');

      this.userService.verifyUserByActivationCode(this.activationCode).subscribe(data => {
        console.log(data);
        this.data = data;
        this.showResetPassword = true;
        this.header = "HRWE.RESET-PASSWORD.TITLE_RESET_PASSWORD";
        this.spinnerService.stop();
      });
    }
  }

  get f() { return this.repeatPasswordForm.controls; }

  get val() { return this.repeatPasswordForm.value; }

  repeatPasswordFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      password: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-12])(?=.*[$@$!%*?&.])[A-Za-z\d$@$!%*.?&].{11,}')]],
      re_password: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-12])(?=.*[$@$!%*?&.])[A-Za-z\d$@$!%*.?&].{11,}')]]
    });
  }

  passwordValidation() {
    this.spinnerService.start();
    this.confirmPasswordCheck = this.repeatPasswordForm.value.password != "" && this.repeatPasswordForm.value.re_password != "" && this.repeatPasswordForm.value.password != this.repeatPasswordForm.value.re_password;
    this.spinnerService.stop();
  }

  onSubmit() {
    this.spinnerService.start();
    this.submitted = true;
    this.error = false;
    this.showConfirmMsg = false;

    if (this.repeatPasswordForm.invalid) {
      this.commonUtilService.findInvalidControls(this.repeatPasswordForm);
      this.error = true;
      this.spinnerService.stop();
      return;
    }

    let dataJson = {
      "activationCode": this.activationCode,
      "password": this.repeatPasswordForm.value.password
    }

    if (this.showResetPassword) {
      this.userService.updatePassword(dataJson).subscribe(data => {
        this.showConfirmMsg = true;
        this.data = null;

        setTimeout(() => { window.location.href = '/sso'; }, 7000);
      }, err => {
        this.error = true;
        this.spinnerService.stop();
        setTimeout(()=>{                           
          this.error = false;
        }, 2000);
      });
    } else {
      this.userService.changePassword(dataJson).subscribe(data => {
        this.showConfirmMsgAlert = true;
        setTimeout(() => { window.location.reload() }, 1000);
      }, err => {
        this.error = true;
        this.spinnerService.stop();
        setTimeout(()=>{                           
          this.error = false;
        }, 2000);
      });
    }
  }
}
